import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetcher } from "../utils/Fetcher";

const API_URL = process.env.REACT_APP_API_URL;

export const useLandingPageData = () => {
  const { i18n } = useTranslation();
  const [dataByLocale, setDataByLocale] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const didFetch = useRef(false);

  const changeLocale = (newLocale) => {
    i18n.changeLanguage(newLocale);
  };

  const locale = i18n.language?.split("-")[0] ?? "ru";

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;

    const fetchAll = async () => {
      setLoading(true);
      setError(null);

      try {
        const [ruRes, ukRes] = await Promise.all([
          fetcher(`${API_URL}/api/landing?locale=ru&pLevel`),
          fetcher(`${API_URL}/api/landing?locale=uk&pLevel`),
        ]);

        setDataByLocale({
          ru: ruRes.data,
          uk: ukRes.data,
        });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  return {
    data: dataByLocale[locale],
    locale,
    changeLocale,
    loading,
    error,
  };
};
